export const articles = [
  {
    id: 'micros-vs-minis',
    category: 'Gestão de Risco',
    categoryIcon: 'ri-shield-check-line',
    title: 'Micros vs Minis: Por Que os Contratos Micro São a Arma Secreta nas Prop Firms',
    excerpt: 'Usar contratos Micro em vez de Mini não é só uma questão de risco — é uma estratégia inteligente que te permite gerir posições com mais precisão, garantir profits parciais e sobreviver ao drawdown.',
    image: 'https://public.readdy.ai/ai/img_res/4861fc86e303b3efd6f10dc8e32d7965.jpg',
    readTime: '11 min',
    date: '11 Abr 2026',
    author: 'Carlos Mendes',
    authorRole: 'Trader Profissional',
    featured: true,
    content: [
      {
        type: 'intro',
        text: 'A maioria dos traders iniciantes pensa nos contratos Micro como "a versão barata para quem não tem capital". Isso é um erro. Os Micros são uma ferramenta de gestão de risco e de execução que traders profissionais usam deliberadamente — especialmente em prop firms onde o drawdown é lei.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=ninjatrader%20platform%20screen%20showing%20MES%20micro%20emini%20SP500%20futures%2015%20minute%20chart%20bullish%20trend%20candlestick%20bars%20dark%20background%20volume%20histogram%20real%20intraday%20prop%20firm%20session&width=1200&height=600&seq=mv2d&orientation=landscape',
        caption: 'MES (Micro E-mini S&P 500) no M15 no NinjaTrader — exatamente o mesmo gráfico que o ES, com risco 10x menor por tick'
      },
      {
        type: 'heading',
        text: 'O Que São os Contratos Micro?'
      },
      {
        type: 'text',
        text: 'Os contratos Micro são exatamente 1/10 do tamanho dos contratos E-mini. Foram introduzidos pelo CME Group em 2019 e tornaram-se rapidamente populares entre traders de todos os níveis. Cada Micro tem a mesma liquidez, o mesmo preço e o mesmo comportamento que o seu equivalente Mini — apenas o valor por tick é 10x menor.'
      },
      {
        type: 'highlight',
        title: 'MES — Micro E-mini S&P 500',
        text: 'Tick size: 0.25 pontos = $1.25 por contrato (vs $12.50 do ES). Margem intraday típica: $40-100. Ideal para contas entre $5k e $50k onde o controlo de risco é crítico.'
      },
      {
        type: 'highlight',
        title: 'MNQ — Micro E-mini Nasdaq 100',
        text: 'Tick size: 0.25 pontos = $0.50 por contrato (vs $5.00 do NQ). Volatilidade alta do Nasdaq com risco 10x menor. Permite operar o instrumento mais volátil do mercado com total controlo.'
      },
      {
        type: 'highlight',
        title: 'MGC e MCL — Micro Ouro e Micro Crude Oil',
        text: 'Micro Gold (MGC): 1/10 do GC, $1 por tick. Micro Crude Oil (MCL): 1/10 do CL, $1 por tick. Acesso à volatilidade das commodities com risco controlado — perfeito para traders que querem diversificar.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=trading%20platform%20screen%20showing%20MNQ%20micro%20nasdaq%20100%20futures%201%20minute%20chart%20scalping%20session%20dark%20terminal%20green%20red%20candles%20real%20time%20price%20action%20funded%20account%20prop%20firm&width=1200&height=500&seq=mv3c&orientation=landscape',
        caption: 'MNQ no M1 durante uma sessão de scalping — o mesmo comportamento do NQ, com o custo de cada erro dividido por 10'
      },
      {
        type: 'heading',
        text: 'Vantagem 1 — Risco Real vs. Risco Percebido'
      },
      {
        type: 'text',
        text: 'Nas prop firms, o drawdown é calculado em dólares reais. Um stop loss de 10 pontos no NQ significa $500 de perda por contrato. No MNQ, o mesmo stop loss custa apenas $50. Esta diferença transforma completamente a psicologia da operação — e a sobrevivência da conta.'
      },
      {
        type: 'text',
        text: 'Imagina uma conta de $50k com daily drawdown de $1.500. Com um Mini NQ, se o setup falhar 3 vezes com stop de 10 pontos, a tua conta está terminada para o dia. Com Micros MNQ, as mesmas 3 perdas custam $150 — tens 10x mais tentativas antes de atingires o limite.'
      },
      {
        type: 'heading',
        text: 'Vantagem 2 — Profits Parciais com Precisão Cirúrgica'
      },
      {
        type: 'text',
        text: 'Esta é a vantagem mais subestimada dos Micros, e a razão pela qual traders experientes os preferem mesmo tendo capital para os Minis. Com contratos Micro, podes fechar uma percentagem exata da posição em cada alvo — algo impossível de fazer com apenas 1 ou 2 contratos Mini.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=futures%20intraday%20chart%20showing%20three%20horizontal%20profit%20target%20lines%20first%20second%20third%20take%20profit%20levels%20entry%20point%20long%20trade%20NQ%20nasdaq%20dark%20terminal%20candlestick%20bars%20prop%20firm%20session&width=1200&height=500&seq=mv4c&orientation=landscape',
        caption: 'Setup long no NQ com T1, T2 e T3 definidos — ao fechar parciais em cada alvo com Micros, o risco desaparece progressivamente'
      },
      {
        type: 'text',
        text: 'Um exemplo prático: entras com 10 MNQ num setup bullish no NQ. O teu plano tem 3 targets: T1 a 20 pontos, T2 a 40 pontos, T3 a 80 pontos. Ao atingires T1, fechas 5 MNQ (50%) e garantis $500 de lucro. Moves o stop para breakeven nos restantes 5. Ao atingires T2, fechas mais 3 MNQ. Deixas 2 correr para T3 ou até o trailing stop ser atingido. Resultado: nunca podes perder a operação.'
      },
      {
        type: 'heading',
        text: 'Vantagem 3 — Stop a Breakeven Sem Medo'
      },
      {
        type: 'text',
        text: 'Um dos momentos mais difíceis no trading é mover o stop para breakeven depois de um profit parcial. Com um Mini, se tiveres apenas 1 contrato, fechar 50% não é possível — tens de fechar tudo ou nada. Com 10 Micros, a lógica é simples: fechas metade, moves o stop e estás psychologicamente em paz porque não podes perder o trade.'
      },
      {
        type: 'quote',
        text: 'A diferença entre um trader consistente e um trader que explode contas está muitas vezes na capacidade de garantir profits parciais. Os Micros tornam essa técnica acessível a qualquer tamanho de conta.',
        author: 'Diário de 1 Trader'
      },
      {
        type: 'heading',
        text: 'Vantagem 4 — Gestão de Drawdown nas Prop Firms'
      },
      {
        type: 'text',
        text: 'As prop firms são implacáveis com o drawdown. Um dia mau com Minis pode destruir semanas de trabalho. Com Micros, cada perda individual é menor, o que significa que podes manter a consistência mesmo em séries de perdas temporárias — algo que as prop firms adoram ver nos relatórios.'
      },
      {
        type: 'list',
        items: [
          'Drawdown diário de 3% numa conta $100k = $3.000 de limite',
          'Com 1 Mini NQ e stop de 30 pontos = $600 de perda (20% do limite num trade)',
          'Com 10 Micro MNQ e o mesmo stop = $60 de perda (apenas 2% do limite)',
          'Com Micros, podes perder 50 trades consecutivos antes de atingir o daily drawdown',
          'Mais tentativas = mais dados = melhor aprendizagem = mais consistência',
          'As prop firms valorizam consistência acima de lucros grandes — os Micros ajudam-te a ser consistente'
        ]
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=futures%20trading%205%20minute%20chart%20breakeven%20stop%20loss%20moved%20up%20after%20partial%20close%20entry%20level%20candlestick%20dark%20platform%20emini%20prop%20firm%20intraday%20trade%20management%20funded%20account&width=1200&height=500&seq=mv5d&orientation=landscape',
        caption: 'Stop movido para breakeven no ES após fechar T1 — com Micros nunca podes perder a operação depois de garantir o primeiro parcial'
      },
      {
        type: 'heading',
        text: 'Estratégia de Scale-In com Micros'
      },
      {
        type: 'text',
        text: 'Além do scale-out (fechar parciais), os Micros permitem também o scale-in — entrar progressivamente numa posição à medida que o mercado confirma a direção. Com um Mini, só podes ter 1 contrato. Com 10 Micros, podes entrar com 3 no setup inicial, adicionar 3 após confirmação e os últimos 4 após o primeiro breakout.'
      },
      {
        type: 'highlight',
        title: 'Scale-In Progressivo — Como Fazer',
        text: 'Exemplo no MES: Setup em zona de suporte. Entras com 3 MES na zona. O preço confirma com vela bullish — adicionas 4 MES. O preço quebra o high anterior — adicionas os últimos 3 MES. Total: 10 MES, posição construída de forma inteligente com risco inicial mínimo.'
      },
      {
        type: 'heading',
        text: 'Quando Usar Minis em Vez de Micros?'
      },
      {
        type: 'text',
        text: 'Os Micros não são sempre a melhor opção. Em contas grandes (acima de $200k) onde o profit target obriga a fazer movimentos significativos, os Minis são mais eficientes em termos de comissões. Cada contrato tem o mesmo custo de comissão independentemente de ser Micro ou Mini — com Micros, para a mesma exposição, pagas 10x mais em comissões.'
      },
      {
        type: 'list',
        items: [
          'Conta $10k-$100k em prop firm: usa Micros quase sempre',
          'Conta $100k-$200k: mistura Micros (gestão de risco) e Minis (eficiência)',
          'Conta acima de $200k: Minis com gestão cuidadosa de tamanho de posição',
          'Avaliações/challenges: sempre Micros — o objetivo é passar, não lucrar ao máximo',
          'Mercados muito voláteis (NQ, CL): considera descer para Micros mesmo em contas grandes',
          'Se tens dúvidas, começa sempre com o Micro do instrumento que queres operar'
        ]
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=prop%20firm%20funded%20account%20equity%20curve%20chart%20showing%20consistent%20upward%20growth%20daily%20profits%20small%20drawdowns%20green%20line%20rising%20steadily%20trading%20dashboard%20performance%20report&width=1200&height=500&seq=mv6c&orientation=landscape',
        caption: 'Curva de equity de uma conta prop firm gerida com Micros — crescimento consistente e drawdowns pequenos, exatamente o que as prop firms querem ver'
      },
      {
        type: 'heading',
        text: 'Plano de Gestão com 10 Micros — Exemplo Completo'
      },
      {
        type: 'text',
        text: 'Aqui está um exemplo de como estruturar um trade completo no MNQ com 10 contratos Micro, usando profits parciais e gestão de risco profissional:'
      },
      {
        type: 'list',
        items: [
          'Entrada: 10 MNQ a 19.500, stop a 19.480 (20 pontos, $100 de risco total)',
          'Target 1 (T1): 19.540 (+40 pontos) — fechar 4 MNQ, lucro de $80, stop move para breakeven',
          'Target 2 (T2): 19.580 (+80 pontos) — fechar 3 MNQ, mais $120 de lucro',
          'Target 3 (T3): trailing stop nos restantes 3 MNQ — deixa correr',
          'Se T1 for atingido, a operação nunca pode perder dinheiro',
          'Lucro mínimo garantido após T1: $80. Lucro máximo: ilimitado com trailing stop'
        ]
      },
      {
        type: 'quote',
        text: 'Não precisas de fazer trades grandes para ganhar bem. Precisas de fazer trades bem geridos. 10 Micros com 3 targets é mais poderoso do que 1 Mini com um único target.',
        author: 'Diário de 1 Trader'
      }
    ]
  },
  {
    id: 'forex-prop-firms',
    category: 'Prop Firms',
    categoryIcon: 'ri-exchange-dollar-line',
    title: 'Trading de Forex com Prop Firms: Como Reduzir o Risco e Operar com Capital Financiado',
    excerpt: 'Operar Forex com o teu próprio capital é arriscado. Com uma prop firm especializada em Forex como a ThinkCapital, podes negociar com até €200.000 e arriscar apenas a taxa de avaliação.',
    image: 'https://readdy.ai/api/search-image?query=forex%20trading%20currency%20pairs%20chart%20eurusd%20gbpusd%20professional%20dark%20terminal%20candlestick%20real%20time%20funded%20account%20prop%20firm%20capital%20trading%20session&width=800&height=500&seq=fx1&orientation=landscape',
    readTime: '13 min',
    date: '11 Abr 2026',
    author: 'Carlos Mendes',
    authorRole: 'Trader Profissional',
    featured: true,
    content: [
      {
        type: 'intro',
        text: 'Fazer trading de Forex com o teu próprio dinheiro tem um problema fundamental: o risco é todo teu. Uma série de perdas pode destruir meses de poupanças. As prop firms mudaram isto completamente — operas com o capital delas, guardas a maioria dos lucros e o teu risco máximo é a taxa de avaliação. Para Forex especificamente, a ThinkCapital é hoje considerada a melhor opção do mercado europeu.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=forex%20currency%20trading%20EURUSD%20live%20chart%20dark%20professional%20terminal%20real%20time%20candlestick%20bars%20funded%20prop%20firm%20account%20dashboard%20currency%20pairs%20multiple%20monitors&width=1200&height=600&seq=fx2&orientation=landscape',
        caption: 'Trading de Forex com capital financiado — o mesmo mercado, mas sem arriscar as tuas poupanças'
      },
      {
        type: 'heading',
        text: 'Por Que o Forex é Ideal para Prop Firms?'
      },
      {
        type: 'text',
        text: 'O mercado Forex (câmbio de divisas) é o maior mercado financeiro do mundo, com mais de $7 biliões negociados por dia. Opera 24 horas por dia, 5 dias por semana — o que significa que podes fazer trading antes do trabalho, à noite, ou em qualquer horário que te convenha. Para traders portugueses, isso é uma vantagem enorme.'
      },
      {
        type: 'text',
        text: 'Mas a característica que torna o Forex perfeito para prop firms é a sua liquidez extrema. Os spreads são baixos, as ordens são executadas instantaneamente e há sempre contraparte disponível. Isso significa que as prop firms conseguem oferecer condições muito competitivas para Forex — melhor do que para futuros ou acções.'
      },
      {
        type: 'highlight',
        title: 'Forex vs. Futuros em Prop Firms',
        text: 'Futuros têm sessões fixas e pausas overnight. Forex opera 24h/5d, sem interrupções. Para traders que não podem operar durante a sessão americana (14:30-21:00), o Forex é a alternativa perfeita — podes fazer trading na sessão asiática ou europeia com a mesma liquidez.'
      },
      {
        type: 'highlight',
        title: 'Alavancagem Controlada',
        text: 'As prop firms oferecem alavancagem nos pares Forex, mas dentro dos limites das suas regras de drawdown. Isso é paradoxalmente mais seguro do que operar Forex por conta própria com alavancagem máxima — tens um limite claro de quanto podes perder.'
      },
      {
        type: 'cta',
        title: 'Começa com a ThinkCapital — A Melhor Prop Firm para Forex',
        text: 'Avaliação em apenas 1 fase, 70+ pares de Forex, profit split de 90% e payouts semanais. Usa o código DIARIO1 para 10% de desconto na avaliação.',
        buttonText: 'Abrir Conta ThinkCapital',
        buttonUrl: 'https://checkout.thinkcapital.com/?refcode=NUNO001',
        coupon: 'DIARIO1'
      },
      {
        type: 'heading',
        text: 'Como Funciona uma Prop Firm de Forex?'
      },
      {
        type: 'text',
        text: 'O modelo é simples e muito atraente para o trader. Pagas uma taxa de avaliação (geralmente €80-€250 dependendo do tamanho da conta que queres). Completas um desafio que demonstra que consegues operar de forma consistente e controlada. Se passares, recebes uma conta financiada com o capital real da prop firm e ficas com 80-90% dos lucros que gerares.'
      },
      {
        type: 'text',
        text: 'O teu risco máximo é sempre a taxa de avaliação que pagaste. A prop firm assume o risco do capital — se perderes a conta financiada, não perdes nada mais do que já pagaste. É uma forma extraordinariamente eficiente de fazer trading com capital elevado sem o capital elevado.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=prop%20firm%20evaluation%20process%20steps%20funded%20account%20forex%20trading%20professional%20infographic%20flow%20chart%20dark%20background%20clean%20modern%20terminal&width=1200&height=500&seq=fx3&orientation=landscape',
        caption: 'O processo de avaliação até à conta financiada — na ThinkCapital são apenas 3 passos'
      },
      {
        type: 'heading',
        text: 'ThinkCapital: A Melhor Escolha para Forex em 2026'
      },
      {
        type: 'text',
        text: 'Existem dezenas de prop firms no mercado, mas para trading de Forex especificamente, a ThinkCapital destaca-se por razões muito concretas. Não é marketing — é uma análise das condições reais que oferecem comparadas com a concorrência.'
      },
      {
        type: 'highlight',
        title: 'Avaliação em 1 Fase',
        text: 'A maioria das prop firms exige 2 fases de avaliação — a ThinkCapital tem apenas 1. Isso significa que passas para conta financiada mais rapidamente e com menos tempo de stress. Para traders de Forex com um sistema comprovado, isto é uma vantagem decisiva.'
      },
      {
        type: 'highlight',
        title: '70+ Pares de Forex Disponíveis',
        text: 'Forex majors, minors e exóticos — a ThinkCapital oferece mais de 70 pares. Se tens estratégias em GBPUSD, USDJPY, AUDUSD ou mesmo pares exóticos como USDMXN, podes executá-las todas na mesma conta.'
      },
      {
        type: 'highlight',
        title: '90% Profit Split + Payouts Semanais',
        text: 'Ficas com 90% de tudo o que ganhas. E não tens de esperar um mês para receber — os payouts são semanais. Para traders que querem construir rendimento consistente, isto é fundamental.'
      },
      {
        type: 'highlight',
        title: 'Drawdown de 10% Max / 5% Diário',
        text: 'Regras de drawdown equilibradas — nem demasiado restritivas que tornam a aprovação impossível, nem tão largas que encorajam comportamentos de risco. O drawdown de 5% diário numa conta de €100k dá-te €5.000 de espaço para operar confortavelmente.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=ThinkCapital%20prop%20firm%20funded%20forex%20trading%20account%20dashboard%20profit%20weekly%20payout%20funded%20trader%20professional%20terminal%20dark%20green%20positive%20equity&width=1200&height=500&seq=fx4&orientation=landscape',
        caption: 'Dashboard de conta financiada ThinkCapital — profit split de 90% com payouts semanais'
      },
      {
        type: 'cta',
        title: 'Poupa 10% na Tua Avaliação ThinkCapital',
        text: 'Usa o código exclusivo DIARIO1 no checkout e poupa 10% imediatamente. Avaliação em 1 fase, contas de €10.000 a €200.000.',
        buttonText: 'Obter Desconto com DIARIO1',
        buttonUrl: 'https://checkout.thinkcapital.com/?refcode=NUNO001',
        coupon: 'DIARIO1'
      },
      {
        type: 'heading',
        text: 'Como Reduzir o Risco com Prop Firms de Forex'
      },
      {
        type: 'text',
        text: 'A grande vantagem das prop firms é que transformam o perfil de risco do trading radicalmente. Sem prop firm: tens €10.000 no mercado, perdes €2.000, é dinheiro teu. Com prop firm: pagas €150 de avaliação, recebes €100.000 de capital, e se correr mal o teu risco máximo foram os €150.'
      },
      {
        type: 'list',
        items: [
          'Risco máximo limitado à taxa de avaliação (nunca ao capital total)',
          'Regras de drawdown forçam disciplina que muitos traders não têm sozinhos',
          'O stress psicológico é muito menor quando o capital não é teu',
          'Podes testar estratégias com capital real sem hipotecar o futuro',
          'Se perderes a conta, simplesmente fazes nova avaliação — o capital da conta não é teu',
          'As prop firms têm interesse em que passes — fornecem suporte e educação'
        ]
      },
      {
        type: 'heading',
        text: 'Estratégias de Forex que Funcionam em Prop Firms'
      },
      {
        type: 'text',
        text: 'Nem todas as estratégias de Forex são adequadas para prop firms. As regras de drawdown excluem estratégias de alta frequência agressiva ou martingale. As melhores estratégias para ambientes de prop firms são as que oferecem consistência sobre grandes ganhos isolados.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=forex%20trading%20strategy%20chart%20EURUSD%204%20hour%20timeframe%20support%20resistance%20levels%20entry%20signal%20dark%20terminal%20professional%20clean%20funded%20account%20prop%20firm&width=1200&height=500&seq=fx5&orientation=landscape',
        caption: 'Setup de Forex no H4 com suportes e resistências bem definidos — o tipo de estratégia ideal para prop firms'
      },
      {
        type: 'highlight',
        title: 'Price Action nos Pares Majors',
        text: 'EURUSD, GBPUSD e USDJPY têm os spreads mais baixos e a melhor liquidez. Estratégias de price action puro (suportes, resistências, padrões de velas) funcionam consistentemente nestes pares — e são facilmente replicáveis de dia para dia.'
      },
      {
        type: 'highlight',
        title: 'Sessão de Londres + Overlap',
        text: 'A sessão de Londres (08:00-12:00 Lisboa) e o overlap London/NY (14:30-17:00 Lisboa) são os melhores momentos para Forex. Volatilidade alta, spreads baixos, movimentos técnicos limpos. Para traders portugueses, estas janelas são perfeitamente convenientes.'
      },
      {
        type: 'highlight',
        title: 'Tendência + Pullback no H1/H4',
        text: 'Identificar a tendência no H4 ou Daily, e entrar nos pullbacks no H1. Estratégia clássica mas altamente eficaz em Forex — especialmente com os filtros de gestão de risco que as prop firms impõem naturalmente.'
      },
      {
        type: 'heading',
        text: 'Gestão de Risco Específica para Forex em Prop Firms'
      },
      {
        type: 'text',
        text: 'O Forex tem características de risco diferentes dos futuros. Os pares podem ficar em range durante horas e depois mover-se rapidamente com notícias económicas. Para proteger a tua conta financiada, algumas regras específicas são essenciais.'
      },
      {
        type: 'list',
        items: [
          'Evita manter posições abertas durante notícias de alto impacto (NFP, CPI, decisões do BCE/FED)',
          'Usa stop loss sempre — sem excepções, em todos os trades',
          'Não trades o GBPUSD em períodos de alta volatilidade sem experiência nesse par',
          'Cuidado com pares exóticos — spreads alargam significativamente fora das horas principais',
          'Define o teu risk:reward mínimo de 1:1.5 — com 40% de win rate ainda és lucrativo',
          'Limita-te a 2-3 pares que conheces bem — profundidade bate largura no Forex'
        ]
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=forex%20risk%20management%20stop%20loss%20position%20sizing%20currency%20trading%20professional%20terminal%20dark%20background%20funded%20account%20drawdown%20rules%20prop%20firm%20chart&width=1200&height=500&seq=fx6&orientation=landscape',
        caption: 'Gestão de risco rigorosa é o que separa os traders que mantêm contas financiadas dos que as perdem'
      },
      {
        type: 'heading',
        text: 'Quanto Podes Ganhar com Forex em Prop Firms?'
      },
      {
        type: 'text',
        text: 'Vamos a números concretos. Considera uma conta ThinkCapital de €100.000 com profit split de 90%. Se gerares 2% de retorno por mês (muito razoável em Forex com boa gestão), isso é €2.000 brutos. O teu pagamento é €1.800 por mês. Com a taxa de avaliação de ~€199, o retorno sobre o investimento inicial em 1 mês é de +800%.'
      },
      {
        type: 'text',
        text: 'Mas os melhores traders de prop firms escalam progressivamente. Começam com €25.000, provam consistência, avançam para €50.000, depois €100.000, depois €200.000. A ThinkCapital permite scaling até €200.000 com as mesmas regras — e continuam a receber 90% dos lucros.'
      },
      {
        type: 'cta',
        title: 'Pronto para Começar com Capital Financiado?',
        text: 'A ThinkCapital é a prop firm com a melhor relação qualidade-preço para Forex em 2026. Avaliação em 1 fase, 90% profit split, 70+ pares, payouts semanais. Usa o código DIARIO1 para 10% de desconto.',
        buttonText: 'Começar Agora com 10% OFF',
        buttonUrl: 'https://checkout.thinkcapital.com/?refcode=NUNO001',
        coupon: 'DIARIO1'
      },
      {
        type: 'heading',
        text: 'Perguntas Frequentes sobre Forex em Prop Firms'
      },
      {
        type: 'text',
        text: 'Antes de começares, aqui estão as respostas às dúvidas mais comuns de traders portugueses sobre Forex em prop firms:'
      },
      {
        type: 'list',
        items: [
          'Preciso de experiência prévia em Forex? — Sim, recomendamos pelo menos 3 meses em conta demo antes da avaliação',
          'Posso manter posições Forex abertas durante o fim de semana? — Depende das regras da prop firm; na ThinkCapital é permitido com cuidado',
          'O que acontece se perder a conta financiada? — Perdes o acesso à conta, mas não perdes mais do que já pagaste na avaliação',
          'Posso usar Expert Advisors (EAs/bots) em Forex? — Algumas prop firms permitem, mas verifica os termos da ThinkCapital',
          'Quanto tempo demora a passar a avaliação? — Com disciplina, entre 15-30 dias de trading',
          'Os lucros são pagos em euros? — Sim, a ThinkCapital paga em EUR com payouts semanais'
        ]
      },
      {
        type: 'quote',
        text: 'A prop firm não é um atalho — é uma alavanca. Se já sabes fazer trading de Forex de forma consistente, a ThinkCapital dá-te o capital para transformar essa habilidade em rendimento real, sem arriscar as tuas poupanças.',
        author: 'Diário de 1 Trader'
      }
    ]
  },
  {
    id: 'psicologia-trading',
    category: 'Psicologia',
    categoryIcon: 'ri-mental-health-line',
    title: 'Psicologia do Trading: Como Controlar as Emoções para Ter Sucesso',
    excerpt: 'A psicologia é responsável por 80% do sucesso no trading. Aprenda a controlar o FOMO, a ganância e o medo para tomar melhores decisões.',
    image: 'https://readdy.ai/api/search-image?query=trading%20psychology%20mental%20discipline%20calm%20focus%20meditation%20professional%20trader%20mindset%20blue%20professional%20elegant&width=800&height=500&seq=a1&orientation=landscape',
    readTime: '8 min',
    date: '10 Abr 2026',
    author: 'Carlos Mendes',
    authorRole: 'Trader Profissional',
    featured: true,
    content: [
      {
        type: 'intro',
        text: 'Podes ter a melhor estratégia do mundo, o melhor setup técnico, as melhores ferramentas — mas se a tua cabeça não estiver no lugar certo, vais perder dinheiro. A psicologia do trading é o fator mais subestimado e ao mesmo tempo o mais determinante para o sucesso a longo prazo.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=trader%20sitting%20calm%20meditation%20before%20trading%20session%20morning%20routine%20discipline%20mindset%20professional%20office%20blue%20tones&width=1200&height=600&seq=ap1&orientation=landscape',
        caption: 'A rotina pré-sessão é fundamental para entrar no mercado com a mentalidade certa'
      },
      {
        type: 'heading',
        text: 'Os 3 Inimigos Emocionais do Trader'
      },
      {
        type: 'text',
        text: 'Existem três emoções que destroem a conta de praticamente todos os traders iniciantes — e de muitos avançados. Identificá-las é o primeiro passo para as dominar.'
      },
      {
        type: 'highlight',
        title: 'FOMO — Fear of Missing Out',
        text: 'Entras numa operação tarde porque tens medo de perder o movimento. Resultado: entras no topo, o preço reverte e perdes. O FOMO é especialmente perigoso após uma série de vitórias — a confiança excessiva leva-te a forçar trades que não existem no plano.'
      },
      {
        type: 'highlight',
        title: 'Ganância',
        text: 'Moves o take profit mais longe porque "o mercado vai continuar". Não respeitas o plano de saída. Closes uma operação lucrativa com 20% do potencial porque ficaste com medo. A ganância manifesta-se de formas opostas: querer ganhar mais OU ter medo de perder o que já ganhámos.'
      },
      {
        type: 'highlight',
        title: 'Revenge Trading',
        text: 'Após uma perda, abres uma nova posição imediatamente para "recuperar". É a causa número um de blown accounts. Uma perda de 2% pode transformar-se numa perda de 20% em menos de 1 hora de revenge trading descontrolado.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=emotions%20wheel%20fear%20greed%20psychology%20trading%20chart%20professional%20diagram%20blue%20dark%20background%20clean%20modern&width=1200&height=500&seq=ap2&orientation=landscape',
        caption: 'O ciclo emocional do trader — reconhecer onde estás é essencial'
      },
      {
        type: 'heading',
        text: 'Como Construir Disciplina Mental no Trading'
      },
      {
        type: 'text',
        text: 'A disciplina não é um talento — é um sistema. Os melhores traders do mundo não têm controlo emocional perfeito porque são especiais. Têm-no porque criaram regras que tornam as emoções irrelevantes para a tomada de decisão.'
      },
      {
        type: 'list',
        items: [
          'Escreve o teu plano de trading antes de abrir a plataforma. Sem plano, sem trade.',
          'Define os critérios de entrada, stop loss e take profit ANTES de entrar na operação.',
          'Estabelece um número máximo de perdas diárias. Se atingires, fecha o computador.',
          'Faz journaling de cada operação — o que pensaste, o que sentiste, o que aconteceu.',
          'Medita ou faz exercício antes de cada sessão de trading.',
          'Nunca trades com dinheiro que não podes perder — o stress financeiro destruirá a tua disciplina.'
        ]
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=trading%20journal%20notebook%20pen%20analysis%20professional%20trader%20writing%20notes%20discipline%20system%20process%20clean%20minimal&width=1200&height=500&seq=ap3&orientation=landscape',
        caption: 'O diário de trading é a ferramenta mais poderosa para o desenvolvimento psicológico'
      },
      {
        type: 'heading',
        text: 'A Importância do Processo vs. Resultado'
      },
      {
        type: 'text',
        text: 'Um dos maiores erros psicológicos no trading é avaliar as operações pelo resultado e não pelo processo. Uma boa operação pode perder dinheiro. Uma má operação pode ganhar dinheiro. O mercado tem aleatoriedade no curto prazo — o que controlas é a qualidade das tuas decisões.'
      },
      {
        type: 'quote',
        text: 'O objetivo não é estar certo — é seguir o processo e deixar as probabilidades funcionarem ao longo do tempo. Numa amostra de 100 operações, a tua edge (vantagem) mostrará os seus resultados.',
        author: 'Mark Douglas, Trading in the Zone'
      },
      {
        type: 'heading',
        text: 'Ferramentas Práticas para Gestão Emocional'
      },
      {
        type: 'text',
        text: 'Além das práticas mentais, existem ferramentas concretas que ajudam a manter a estabilidade emocional durante as sessões de trading:'
      },
      {
        type: 'list',
        items: [
          'Técnica de respiração 4-7-8 quando sentires stress durante uma operação aberta',
          'Regra dos 10 segundos antes de qualquer trade impulsivo — espera 10 segundos e re-avalia',
          'Timer de pausa obrigatória após 2 perdas consecutivas',
          'Checklist pré-trade em papel — força-te a verificar todos os critérios antes de entrar',
          'Separar o P&L diário da auto-estima — um mau dia não define quem és como trader'
        ]
      }
    ]
  },
  {
    id: 'melhores-sessoes',
    category: 'Mercados',
    categoryIcon: 'ri-time-line',
    title: 'As Melhores Sessões de Trading: Quando Operar para Maximizar Lucros',
    excerpt: 'Nem todas as horas são iguais no trading. Descubra quais as sessões com maior volatilidade e liquidez para os mercados de futuros.',
    image: 'https://readdy.ai/api/search-image?query=world%20trading%20sessions%20london%20new%20york%20tokyo%20financial%20markets%20clock%20timezone%20overlay%20professional%20elegant%20blue&width=800&height=500&seq=a2&orientation=landscape',
    readTime: '6 min',
    date: '8 Abr 2026',
    author: 'Ana Ferreira',
    authorRole: 'Analista de Mercados',
    featured: false,
    content: [
      {
        type: 'intro',
        text: 'O mercado de futuros opera quase 24 horas por dia, mas isso não significa que deves operar 24 horas por dia. Existem janelas temporais específicas onde a liquidez e a volatilidade são máximas — e são essas janelas que fazem a diferença entre um trader lucrativo e um trader frustrado.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=world%20map%20financial%20centers%20london%20new%20york%20tokyo%20global%20trading%20hours%20clocks%20timezone%20professional%20elegant%20dark%20blue&width=1200&height=600&seq=ms1&orientation=landscape',
        caption: 'As três grandes sessões de trading global — cada uma com as suas características únicas'
      },
      {
        type: 'heading',
        text: 'As 3 Sessões Principais'
      },
      {
        type: 'highlight',
        title: 'Sessão Asiática (00:00 — 09:00 Lisboa)',
        text: 'A sessão asiática (Tóquio, Hong Kong, Singapura) tem volatilidade mais baixa nos instrumentos americanos. É um bom período para análise e preparação, mas geralmente não ideal para trading de futuros americanos como ES e NQ. Exceção: pares de yen (JPY) têm movimento significativo nesta sessão.'
      },
      {
        type: 'highlight',
        title: 'Sessão Londres (08:00 — 17:00 Lisboa)',
        text: 'A sessão londrina é onde o volume começa a crescer significativamente. A abertura de Londres (08:00-10:00) é um dos momentos mais movimentados do dia nos mercados europeus e já começa a influenciar os futuros americanos. Para traders em Portugal, esta é uma sessão conveniente e produtiva.'
      },
      {
        type: 'highlight',
        title: 'Sessão Nova Iorque (14:30 — 21:00 Lisboa)',
        text: 'A sessão americana é de longe a mais importante para futuros como ES, NQ e CL. O pico de volatilidade acontece na abertura (14:30-16:30 Lisboa) e novamente 1h antes do fecho (20:00-21:00). O overlap entre Londres e Nova Iorque (14:30-17:00) é considerado o período de maior liquidez do dia.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=intraday%20volatility%20chart%20trading%20volume%20by%20hour%20financial%20markets%20heatmap%20professional%20data%20visualization%20blue%20dark&width=1200&height=500&seq=ms2&orientation=landscape',
        caption: 'Volume e volatilidade por hora do dia nos futuros americanos — nota os picos na abertura e fecho americano'
      },
      {
        type: 'heading',
        text: 'Os Momentos Mais Importantes do Dia'
      },
      {
        type: 'list',
        items: [
          '08:00-08:30: Abertura europeia — primeiros movimentos do dia',
          '13:30-14:00: Dados económicos americanos (Non-Farm Payrolls, CPI, etc.)',
          '14:30: Abertura oficial de Wall Street — grande movimento inicial',
          '15:30-16:30: Primeira hora americana — tendência do dia estabelece-se',
          '20:00-21:00: Última hora americana — possíveis reversões e fechos de posição',
          '21:00: Fecho americano — depois disto a volatilidade cai drasticamente'
        ]
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=new%20york%20stock%20exchange%20opening%20bell%20wall%20street%20traders%20monitors%20screens%20professional%20financial%20morning%20rush&width=1200&height=500&seq=ms3&orientation=landscape',
        caption: 'A abertura de Wall Street às 14:30 hora de Lisboa é um dos momentos de maior volatilidade'
      },
      {
        type: 'heading',
        text: 'Sessões a Evitar'
      },
      {
        type: 'text',
        text: 'Tão importante quanto saber quando operar é saber quando NÃO operar. Existem períodos onde o mercado se comporta de forma errática e não técnica:'
      },
      {
        type: 'list',
        items: [
          'Entre as 12:00 e as 14:00 (Lisboa) — período de almoço americano, spreads alargam, pouca liquidez',
          'Sextas-feiras à tarde — traders fecham posições para o fim de semana, movimentos irracionais',
          'Vésperas de feriados americanos — volumes muito reduzidos',
          '30 minutos antes de grandes dados económicos — volatilidade extrema sem direção definida',
          'Fim do mês/trimestre — rebalanceamento de fundos pode criar movimentos enganosos'
        ]
      }
    ]
  },
  {
    id: 'melhores-ativos',
    category: 'Ativos',
    categoryIcon: 'ri-stock-line',
    title: 'Os Melhores Ativos para Trading de Futuros em 2026',
    excerpt: 'E-mini S&P 500, Nasdaq, Crude Oil ou Ouro? Analisamos os melhores contratos de futuros por liquidez, volatilidade e custo de operação.',
    image: 'https://readdy.ai/api/search-image?query=futures%20trading%20instruments%20ES%20NQ%20crude%20oil%20gold%20commodities%20index%20multiple%20monitors%20charts%20professional%20financial%20blue&width=800&height=500&seq=a3&orientation=landscape',
    readTime: '10 min',
    date: '5 Abr 2026',
    author: 'Miguel Santos',
    authorRole: 'Especialista em Futuros',
    featured: false,
    content: [
      {
        type: 'intro',
        text: 'Escolher o ativo certo para fazer trading é uma das decisões mais importantes que um trader de futuros pode tomar. Liquidez, volatilidade, custo de operação e o teu estilo de trading são todos fatores que influenciam qual contrato é melhor para ti.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=futures%20contracts%20ES%20NQ%20CL%20GC%20gold%20crude%20oil%20index%20financial%20professional%20multiple%20instruments%20overview%20blue%20dark%20background&width=1200&height=600&seq=ma1&orientation=landscape',
        caption: 'Os principais contratos de futuros americanos — cada um com características únicas'
      },
      {
        type: 'heading',
        text: 'E-mini S&P 500 (ES) — O Rei dos Futuros'
      },
      {
        type: 'text',
        text: 'O ES é o contrato de futuros mais líquido do mundo. Com um tick valendo $12.50 e movimentos médios diários de 30-50 pontos, oferece oportunidades constantes tanto para scalpers como para day traders. É o ponto de partida recomendado para a maioria dos traders.'
      },
      {
        type: 'list',
        items: [
          'Tick size: 0.25 pontos = $12.50 por contrato',
          'Volume médio diário: +1 milhão de contratos',
          'Spread médio: 0.25-0.50 pontos',
          'Sessão principal: 14:30-21:00 Lisboa',
          'Margem típica (intraday): $500-$1.000 por contrato'
        ]
      },
      {
        type: 'highlight',
        title: 'Micro E-mini S&P 500 (MES) — Perfeito para Iniciantes',
        text: 'O MES é 1/10 do tamanho do ES — cada tick vale apenas $1.25. É ideal para traders que querem ganhar experiência em tempo real sem arriscar grandes quantias. Muitas prop firms oferecem contas de avaliação com MES.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=S&P 500 ES futures chart candlestick professional trading terminal multiple timeframes analysis blue dark background clean&width=1200&height=500&seq=ma2&orientation=landscape',
        caption: 'O ES em múltiplos timeframes — o instrumento favorito dos traders profissionais'
      },
      {
        type: 'heading',
        text: 'E-mini Nasdaq 100 (NQ) — Alta Volatilidade'
      },
      {
        type: 'text',
        text: 'O NQ é mais volátil que o ES, com movimentos diários de 150-300 pontos. Cada tick vale $5, o que significa que os movimentos são mais expressivos. É preferido por traders que gostam de capturas maiores mas exige gestão de risco mais rigorosa.'
      },
      {
        type: 'heading',
        text: 'Crude Oil (CL) — Para os Avançados'
      },
      {
        type: 'text',
        text: 'O petróleo bruto é extremamente volátil e influenciado por fatores geopolíticos. Cada ponto vale $1.000, tornando-o num instrumento para traders experientes. Tem correlações fortes com notícias globais e decisões da OPEP.'
      },
      {
        type: 'heading',
        text: 'Ouro (GC) — Proteção e Volatilidade'
      },
      {
        type: 'text',
        text: 'O ouro é um "safe haven" clássico — tende a subir em períodos de incerteza económica. Com cada tick valendo $10, é um instrumento popular entre traders que acompanham os mercados globais. Em 2026, com as tensões geopolíticas actuais, o ouro tem mostrado movimentos excepcionais.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=gold%20futures%20trading%20GC%20commodities%20precious%20metals%20price%20chart%20professional%20financial%20terminal%20dark%20blue%20background&width=1200&height=500&seq=ma3&orientation=landscape',
        caption: 'Futuros de Ouro — um dos instrumentos mais seguidos por traders fundamentalistas'
      },
      {
        type: 'heading',
        text: 'Tabela Comparativa'
      },
      {
        type: 'text',
        text: 'Para escolheres o melhor instrumento, considera: o teu capital disponível, o teu estilo de trading (scalping vs day trading), a tua tolerância ao risco e quantas horas por dia podes dedicar ao mercado. Para iniciantes, MES ou MNQ (Micro Nasdaq) são os pontos de entrada ideais.'
      }
    ]
  },
  {
    id: 'gestao-risco',
    category: 'Gestão de Risco',
    categoryIcon: 'ri-shield-check-line',
    title: 'Gestão de Risco em Prop Firms: Guia Completo para Não Perder a Conta',
    excerpt: 'As prop firms têm regras de drawdown rígidas. Aprenda as melhores práticas de gestão de risco para proteger a sua conta financiada.',
    image: 'https://readdy.ai/api/search-image?query=risk%20management%20trading%20stop%20loss%20position%20sizing%20portfolio%20protection%20shield%20professional%20financial%20blue%20elegant&width=800&height=500&seq=a4&orientation=landscape',
    readTime: '12 min',
    date: '2 Abr 2026',
    author: 'Carlos Mendes',
    authorRole: 'Trader Profissional',
    featured: true,
    content: [
      {
        type: 'intro',
        text: 'Conseguir uma conta financiada numa prop firm é difícil — mantê-la é ainda mais difícil. A gestão de risco não é apenas uma técnica: é a diferença entre ter uma carreira sustentável no trading ou voltares ao início a cada 3 meses.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=risk%20management%20shield%20trading%20account%20protection%20portfolio%20drawdown%20rules%20professional%20financial%20diagram%20blue%20clean&width=1200&height=600&seq=gr1&orientation=landscape',
        caption: 'A gestão de risco é o pilar central de qualquer conta financiada de sucesso'
      },
      {
        type: 'heading',
        text: 'Entender as Regras de Drawdown'
      },
      {
        type: 'text',
        text: 'A maioria das prop firms tem dois tipos de drawdown: o Daily Drawdown (perda máxima num dia) e o Overall Drawdown (perda máxima total). Violares qualquer um deles significa perder a conta imediatamente, sem aviso.'
      },
      {
        type: 'highlight',
        title: 'Daily Drawdown — A Regra Mais Violada',
        text: 'Se o teu daily drawdown é de 3% numa conta de $100k, podes perder no máximo $3.000 num dia. Se às 15:00 já perdeste $2.500, tens de parar — mesmo que aches que o mercado vai recuperar. Muitos traders perdem contas por tentar "recuperar" os $2.500 no mesmo dia.'
      },
      {
        type: 'highlight',
        title: 'Overall/Trailing Drawdown — A Regra Mais Perigosa',
        text: 'Algumas prop firms usam trailing drawdown — o máximo de perda acompanha os teus lucros máximos. Se fizeres $5.000 de lucro e depois perderes $4.000, podes estar mais perto do limite do que pensas. Calcula sempre o teu drawdown real em relação ao equity máximo.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=drawdown%20chart%20equity%20curve%20trading%20account%20loss%20recovery%20professional%20graph%20financial%20analysis%20clean%20blue%20background&width=1200&height=500&seq=gr2&orientation=landscape',
        caption: 'Visualização de drawdown e recuperação — compreender estes conceitos é crítico'
      },
      {
        type: 'heading',
        text: 'O Sistema 1% por Operação'
      },
      {
        type: 'text',
        text: 'A regra de ouro da gestão de risco: nunca arrisques mais de 1% do capital total por operação. Numa conta de $100k, isso significa um máximo de $1.000 de risco por trade. Com este sistema, mesmo com 10 perdas consecutivas, apenas perdeste 10% da conta — recuperável.'
      },
      {
        type: 'list',
        items: [
          'Conta $25k → risco máximo $250 por operação',
          'Conta $50k → risco máximo $500 por operação',
          'Conta $100k → risco máximo $1.000 por operação',
          'Conta $200k → risco máximo $2.000 por operação',
          'Nunca aumentes o risco para "recuperar" perdas anteriores',
          'Nos primeiros 30 dias de uma conta nova, considera usar 0.5%'
        ]
      },
      {
        type: 'heading',
        text: 'Position Sizing Correto'
      },
      {
        type: 'text',
        text: 'O position sizing determina quantos contratos abrir em cada operação. A fórmula é simples: Número de contratos = Risco em $ ÷ (Stop Loss em ticks × valor por tick).'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=position%20sizing%20calculator%20trading%20risk%20reward%20formula%20spreadsheet%20professional%20trader%20tool%20clean%20minimal%20blue&width=1200&height=500&seq=gr3&orientation=landscape',
        caption: 'Calcular o position sizing correto antes de cada operação é obrigatório'
      },
      {
        type: 'heading',
        text: 'Regras de Paragem Diária'
      },
      {
        type: 'text',
        text: 'Para além das regras da prop firm, deves ter as tuas próprias regras de paragem. Profissionalismo no trading significa saber quando parar — antes de atingires o limite da plataforma.'
      },
      {
        type: 'list',
        items: [
          'Para ao atingir 50% do daily drawdown permitido',
          'Para após 3 perdas consecutivas no mesmo dia',
          'Para se notares que estás em modo emocional/revenge',
          'Toma uma pausa de 30 minutos entre sessões de manhã e tarde',
          'Não trades às sextas-feiras se já estás no verde para a semana'
        ]
      }
    ]
  },
  {
    id: 'como-passar-avaliacao',
    category: 'Prop Firms',
    categoryIcon: 'ri-award-line',
    title: 'Como Passar na Avaliação da Prop Firm: Estratégias e Erros a Evitar',
    excerpt: 'A taxa de reprovação nas avaliações de prop firms ultrapassa 90%. Descubra os erros mais comuns e como estruturar o seu plano de trading para passar.',
    image: 'https://readdy.ai/api/search-image?query=prop%20firm%20challenge%20evaluation%20trading%20account%20passing%20checklist%20success%20professional%20financial%20blue%20dark%20background&width=800&height=500&seq=a5&orientation=landscape',
    readTime: '15 min',
    date: '28 Mar 2026',
    author: 'Pedro Oliveira',
    authorRole: 'Mentor de Trading',
    featured: false,
    content: [
      {
        type: 'intro',
        text: 'Mais de 90% dos traders falham nas avaliações de prop firms. A ironia? A maioria não falha por falta de habilidade técnica — falha por impaciência, over-trading e má gestão de risco. Neste guia vais aprender exatamente o que fazer (e o que não fazer) para passar.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=prop%20firm%20challenge%20funded%20trader%20account%20success%20certificate%20professional%20achievement%20financial%20trading%20pass%20evaluation%20blue&width=1200&height=600&seq=pa1&orientation=landscape',
        caption: 'A conta financiada é o objetivo — mas o processo exige disciplina e paciência'
      },
      {
        type: 'heading',
        text: 'Entender as Regras Antes de Começar'
      },
      {
        type: 'text',
        text: 'Cada prop firm tem regras diferentes. Antes de comprares qualquer avaliação, lê os termos com atenção. Os pontos críticos a verificar:'
      },
      {
        type: 'list',
        items: [
          'Daily drawdown: quanto podes perder num dia?',
          'Overall/Max drawdown: qual o limite total de perda?',
          'Profit target: quanto tens de ganhar para passar?',
          'Número mínimo de dias de trading',
          'Regras de overnight — podes manter posições abertas?',
          'Regras de news trading — podes operar durante notícias?',
          'Trailing vs. static drawdown — qual o modelo usado?'
        ]
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=trading%20rules%20checklist%20document%20prop%20firm%20evaluation%20requirements%20professional%20trader%20reading%20terms%20conditions%20blue%20clean&width=1200&height=500&seq=pa2&orientation=landscape',
        caption: 'Ler e compreender cada regra da prop firm antes de começar é fundamental'
      },
      {
        type: 'heading',
        text: 'A Estratégia de Aprovação: Devagar é Depressa'
      },
      {
        type: 'text',
        text: 'O maior erro é tentar passar a avaliação o mais rápido possível. As prop firms querem ver consistência, não heroísmo. Um trader que faz 0.5% por dia de forma consistente passa muito mais facilmente do que um que tenta fazer 5% num dia e depois reverte.'
      },
      {
        type: 'highlight',
        title: 'A Regra dos Pequenos Passos',
        text: 'Num challenge de 10% de profit target, foca em fazer 0.3-0.5% por dia. Em 25-30 dias de trading atinges o objetivo sem nunca arriscar o daily drawdown. É aborrecido? Sim. Funciona? Consistentemente.'
      },
      {
        type: 'highlight',
        title: 'Risco Máximo por Operação durante a Avaliação',
        text: 'Durante a avaliação, reduz o teu risco normal para metade. Se normalmente arriscas 1%, usa 0.5%. Isto dá-te uma margem de segurança maior e reduz o impacto emocional de cada operação individual.'
      },
      {
        type: 'heading',
        text: 'Os 7 Erros Que Destroem as Avaliações'
      },
      {
        type: 'list',
        items: [
          'Over-trading — mais operações não significa mais lucros, significa mais comissões e mais erros',
          'Aumentar o tamanho das posições após lucros para "acelerar" o processo',
          'Operar durante dados económicos sem experiência nessa área',
          'Não respeitar o daily drawdown porque "o mercado vai virar"',
          'Tentar recuperar perdas no mesmo dia (revenge trading)',
          'Operar em condições de mercado que não conheces bem',
          'Começar a avaliação sem estar psicologicamente preparado'
        ]
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=trading%20mistakes%20mistakes%20list%20red%20warning%20signs%20professional%20analysis%20chart%20account%20blowup%20prevention%20education%20blue&width=1200&height=500&seq=pa3&orientation=landscape',
        caption: 'Evitar estes erros é mais importante do que qualquer estratégia técnica'
      }
    ]
  },
  {
    id: 'impostos-traders',
    category: 'Finanças',
    categoryIcon: 'ri-money-euro-circle-line',
    title: 'Impostos para Traders em Portugal: O Que Precisa de Saber em 2026',
    excerpt: 'Como declarar os lucros de prop firms em Portugal? IRS, categoria B ou G? Este guia clarifica tudo sobre a tributação do trading.',
    image: 'https://readdy.ai/api/search-image?query=taxes%20Portugal%20financial%20planning%20trader%20income%20tax%20documents%20professional%20elegant%20blue%20background%20clean&width=800&height=500&seq=a6&orientation=landscape',
    readTime: '9 min',
    date: '25 Mar 2026',
    author: 'Sofia Rodrigues',
    authorRole: 'Consultora Fiscal',
    featured: false,
    content: [
      {
        type: 'intro',
        text: 'A fiscalidade do trading em Portugal é um tema complexo que muitos traders ignoram — até receberem uma notificação da Autoridade Tributária. Com o aumento das prop firms e dos traders portugueses, a AT tem prestado mais atenção a este sector. Aqui está o que precisas de saber em 2026.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=Portugal%20tax%20finance%20documents%20calculator%20IRS%20declaration%20professional%20trader%20income%20financial%20planning%20clean%20blue&width=1200&height=600&seq=it1&orientation=landscape',
        caption: 'A declaração de IRS correcta protege-te de problemas com a Autoridade Tributária'
      },
      {
        type: 'heading',
        text: 'Prop Firms: Rendimento de Categoria B ou G?'
      },
      {
        type: 'text',
        text: 'Esta é a questão mais comum dos traders portugueses. A classificação depende da forma como recebes os pagamentos e da tua relação com a prop firm.'
      },
      {
        type: 'highlight',
        title: 'Categoria B — Trabalho Independente',
        text: 'Se operas como profissional independente (recibos verdes) e o trading é a tua atividade principal, os rendimentos entram na Categoria B. Podes deduzir despesas relacionadas (plataformas, formação, equipamento). A taxa efectiva depende do escalão de IRS e pode chegar a 48% nos rendimentos mais elevados.'
      },
      {
        type: 'highlight',
        title: 'Categoria G — Mais-Valias',
        text: 'Para alguns tipos de ganhos em instrumentos financeiros, pode aplicar-se a Categoria G (mais-valias), com uma taxa de 28%. No entanto, a classificação correcta depende da natureza exacta dos contratos e da prop firm. Recomendamos sempre consultar um contabilista especializado.'
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=IRS%20Portugal%20tax%20rates%20categories%20financial%20professional%20chart%20diagram%20clean%20minimal%20blue%20white%20background&width=1200&height=500&seq=it2&orientation=landscape',
        caption: 'Categorias de IRS e taxas aplicáveis — simplificação para fins educativos'
      },
      {
        type: 'heading',
        text: 'Regime Fiscal Favorável: NHR e IFICI'
      },
      {
        type: 'text',
        text: 'Portugal tem historicamente oferecido regimes fiscais favoráveis para residentes não habituais. Em 2024, o NHR foi substituído pelo IFICI (Incentivo Fiscal à Investigação Científica e Inovação). Traders que se qualifiquem para este regime podem beneficiar de taxas significativamente reduzidas.'
      },
      {
        type: 'heading',
        text: 'O Que Devo Guardar como Documentação?'
      },
      {
        type: 'list',
        items: [
          'Todos os extractos de conta das prop firms (mensais e anuais)',
          'Comprovativos de pagamentos recebidos em EUR',
          'Documentação sobre a natureza dos contratos (termos das prop firms)',
          'Facturas de despesas dedutíveis (software de trading, formação)',
          'Conversões de divisas se recebeste em USD — usar taxa de câmbio do BCE',
          'E-mails e contratos com as prop firms'
        ]
      },
      {
        type: 'image',
        url: 'https://readdy.ai/api/search-image?query=financial%20documents%20organized%20folder%20tax%20records%20professional%20accountant%20desk%20clean%20organized%20blue%20minimal&width=1200&height=500&seq=it3&orientation=landscape',
        caption: 'Organizar a documentação durante o ano poupa horas na época de declarações'
      },
      {
        type: 'heading',
        text: 'Aviso Legal Importante'
      },
      {
        type: 'text',
        text: 'Este artigo tem fins exclusivamente informativos e educacionais. A legislação fiscal portuguesa é complexa e muda regularmente. Para a tua situação específica, consulta sempre um contabilista certificado ou um advogado fiscal especializado. O Diário de 1 Trader não presta aconselhamento fiscal.'
      }
    ]
  }
];
